<template>

  <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :okButtonProps="{ props: { disabled: disableSubmit } }" :maskClosable="maskClosable" @ok="handleOk"
    @cancel="handleCancel" :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
        <a-row :gutter="48">
          <a-col :span="12">
            <a-form-model-item :label="$t('规则名称')" prop="warnName">
              <a-input v-model="model.warnName" :placeholder="$t('请输入规则名称')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('模板')" prop="templateId">
              <a-select v-model="model.templateId" style="width: 100%" :placeholder="$t('请选择模板')" @change="changeTemplate">
                <a-select-option v-for="item in templateList" :value="item.id" :key="item.id">
                  {{ item.templateName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('告警类型')" prop="sendFlag">
              <a-select v-model="model.sendFlag" style="width: 100%" :placeholder="$t('请选择告警类型')">
                <a-select-option v-for="(item, key) in messageSendFlagObj" :value="Number(key)" :key="key">
                  {{ $t(item) }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="model.sendFlag == 1">
            <a-form-model-item :label="$t('告警金额')" prop="valueMin">
              <a-input-number style="width: 100%" v-model="model.valueMin" :placeholder="$t('请输入告警金额')" :min="0"
                :precision="2" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('发送频次')" prop="sendFrequency">
              <a-select v-model="model.sendFrequency" style="width: 100%" :placeholder="$t('请选择发送频次')">
                <a-select-option v-for="(item, key) in messageFrequencyObj" :value="Number(key)" :key="key">
                  {{ $t(item) }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" style="display: flex;align-items: center">
            <a-form-model-item style="display: inline-block;" :label="$t('时间段')" :colon="colon" prop="beginHour">
              <a-input-number :max="23" :min="0" :precision="0" v-model="model.beginHour" placeholder="(0~23)" />
            </a-form-model-item>
            -
            <a-form-model-item style="display: inline-block;" prop="endHour" label=" " :colon="colon">
              <a-input-number :max="23" :min="0" :precision="0" v-model="model.endHour" placeholder="(0~23)" />
              <span class="ant-form-text unit"></span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('是否启用')" prop="enable">
              <a-switch :checked-children="$t('开')" :un-checked-children="$t('关')" v-model="model.enable" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('区域')" prop="sendArea">
              <a-input-search :placeholder="$t('点击选择区域')" v-model="checkedAreaNameString" readOnly @search="onSearchArea">
                <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
              </a-input-search>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注')" prop="remark">
              <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
    <area-window ref="areaWindow" @ok="modalAreaFormOk"></area-window>
  </a-modal>
</template>
<script>

import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { queryAreaTreeList } from '@/api/api'
import { messageFrequencyObj, messageSendFlagObj, messageSendWayObj } from '@/utils/constants/commonConstant'
// 引入搜索区域弹出框的组件
import areaWindow from '@/views/system/modules/areaWindow'
import { listSize } from '@/utils/util'

export default {
  name: 'MessageBaseModal',
  components: {
    areaWindow
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {
        enable: false
      },
      colon: false,
      maskClosable: false,
      title: this.$t('操作'),
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      messageSendFlagObj,
      url: {
        add: "/jeecg-charge/meter/meterMessageConfig/add",
        edit: "/jeecg-charge/meter/meterMessageConfig/edit",
        templateList: "/jeecg-charge/meter/meterMessageBase/list"
      },
      messageFrequencyObj,
      messageSendWayObj,
      checkedAreaKeys: [],
      halfCheckedAreaKeys: [],
      checkedAreaNameString: "", // 保存区域的名称 =>title
      checkedAreaNames: [],
      treeData: [],
      templateList: []
    }
  },
  computed: {
    rules() {
      return {
        warnName: [{ required: true, message: this.$t('请规则名称') }],
        sendFrequency: [{ required: true, message: this.$t('请选择消息发送配置') }],
        templateId: [{ required: true, message: this.$t('请选择模板') }],
        sendFlag: [{ required: true, message: this.$t('请选择告警类型') }],
        valueMin: [{
          required: true,
          message: this.$t('请输入告警金额')
        }],
        beginHour: [
          { required: true, type: 'number', message: this.$t('请输入起始时间') },
          { validator: this.compareToNextHour }
        ],
        endHour: [
          { required: true, type: 'number', message: this.$t('请输入结束时间') },
          //{ validator: this.compareToFirstHour}
        ],
      }
    }
  },
  created() {
  },
  methods: {

    add() {
      this.edit({});
    },
    edit(record) {
      this.model = Object.assign({}, record);
      if (this.model.enable === 1) {
        this.model.enable = true
      }else{
        this.model.enable = false
      }
      this.visible = true;
      this.queryTemplateList();
      this.queryAreaTree();
    },
    changeTemplate(e) {

      this.model.templateId = e
      const target = this.templateList.filter(item => e === item.id)[0]
      if (target) {
        this.model.sendWay = target.flag
      }
      console.log(this.model)
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.formModal.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = Object.assign({}, this.model)
          formData.sendArea = [...this.checkedAreaKeys].join(",");

          if (formData.enable) {
            formData.enable = 1
          } else {
            formData.enable = 0
          }
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
              this.close()
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    close() {
      this.$emit('close');
      this.$refs.formModal.resetFields()
      this.model = this.$options.data.call(this).model
      this.disableSubmit = false;
      this.visible = false;
      this.halfCheckedAreaKeys = [];
      this.checkedAreaKeys = [];
      this.checkedAreaNames = [],
        this.checkedAreaNameString = ''
    },
    compareToFirstHour(rule, value, callback) {
      const beginHour = this.model.beginHour;
      if (value !== "" && beginHour !== "" && value < beginHour) {
        callback(this.$t('时间输入有误'));
      } else {
        callback()
      }
    },
    compareToNextHour(rule, value, callback) {
      const endHour = this.model.endHour;
      if (value !== "" && endHour !== "" && value > endHour) {
        callback(this.$t("时间输入有误"))
      }
      callback()
    },
    handleCancel() {
      this.close();
    },
    queryTemplateList() {
      let params = {};
      params.pageSize = listSize;
      params.pageNo = 1;
      getAction(this.url.templateList, params).then((res) => {
        if (res.success) {
          this.templateList = res.result.records;
        }
      })
    },
    onSearchArea() {
      this.$refs.areaWindow.add(this.checkedAreaKeys, this.halfCheckedAreaKeys, this.treeData, this.checkedAreaNames, this.userId);
    },
    // 获取用户对应部门弹出框提交给返回的数据
    modalAreaFormOk(formData) {
      console.log(formData)
      this.checkedAreaNames = formData.areaNameList;
      this.checkedAreaNameString = this.checkedAreaNames.join(",");
      this.checkedAreaKeys = formData.checkedKeys;
      this.halfCheckedAreaKeys = formData.halfCheckedKeys;
    },
    // queryAreaTree(){
    //   queryAreaTreeList().then((res)=>{
    //     // 过滤出 leaf node 即可，即选中的
    //     // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
    //     // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
    //     if(res.success){
    //       this.treeData = res.result;
    //       const keyLeafPairs = this.convertTreeListToKeyLeafPairs(this.treeData)

    //         const areaNameList = []
    //         const checkedKeys =[]
    //         const halfCheckedKeys = []
    //         debugger;
    //         if(this.model.sendArea!=null&&this.model.sendArea.length>0) {
    //           let areaArr = this.model.sendArea.split(',')
    //           areaArr.forEach(key => {
    //               const keyLeafPair = keyLeafPairs.filter(item => item.key === key)[0]
    //               if(keyLeafPair.leaf) {
    //                   areaNameList.push(keyLeafPair.areaName)
    //                   checkedKeys.push(keyLeafPair.key)
    //               }else {
    //               halfCheckedKeys.push(keyLeafPair.key)
    //               }
    //           })
    //         }
    //         this.checkedAreaKeys = [...checkedKeys];
    //         this.halfCheckedAreaKeys = [...halfCheckedKeys]

    //         this.checkedAreaNames = areaNameList;
    //         this.checkedAreaNameString = this.checkedAreaNames.join(",");

    //     }
    //   })
    // },
    queryAreaTree() {
      queryAreaTreeList().then((res) => {
        // 过滤出 leaf node 即可，即选中的
        // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
        // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
        if (res.success) {
          this.treeData = res.result;
          const keyLeafPairs = this.convertTreeListToKeyLeafPairs(this.treeData)
          const areaNameList = []
          const checkedKeys = []
          const halfCheckedKeys = []
          
          if (this.model.sendArea != null && this.model.sendArea.length > 0) {
            let areaArr = this.model.sendArea.split(',')
            areaArr.forEach(key => {
              const keyLeafPair = keyLeafPairs.filter(item => item.key === key)[0]
              areaNameList.push(keyLeafPair.areaName)
            })
            this.checkedAreaKeys = [...areaArr];

            this.checkedAreaNames = areaNameList;
            this.checkedAreaNameString = this.checkedAreaNames.join(",");
          }
        }
      })
    },
    convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
      for (const { key, leaf, children, areaName } of treeList) {
        keyLeafPair.push({ key, leaf, areaName })
        if (children && children.length > 0) {
          this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
        }
      }
      return keyLeafPair;
    },
  }
}
</script>